import { setLocalStorage } from "./localStorage";


export default function startDashboard(history, data) {
    setLocalStorage("ud", data);
    setLocalStorage("gradeId", data.grade_id);
    setLocalStorage("isLogin", "1");
    setLocalStorage("dashModal", "1");
    setLocalStorage("audioModal", "1");
    setLocalStorage("nonAudioModal", "1");
    history.push("/mappr");
}  